import styled from 'styled-components';

import { EditMIcon } from 'assets/icons';
import { IconButton } from 'components/uikit/IconButton/IconButton';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 44px;
  grid-column-gap: 8px;

  align-items: start;
`;

export const EditButton = styled(IconButton).attrs({ Icon: EditMIcon, theme: '4', size: 'm' })`
  & > svg > path {
    fill: var(--color-black);
  }
`;

export * from '../../Insurance.styles';
